import React from 'react';
import PropTypes from 'prop-types';

const Loader = props => {
  const classLoader = props.onButton
    ? `loader on-button ${props.classLoader}`
    : `loader ${props.classLoader}`;
  return (
    <div className={classLoader}>
      <i className="loading" />
    </div>
  );
};

Loader.propTypes = {
  onButton: PropTypes.bool,
  classLoader: PropTypes.string,
};

Loader.defaultProps = {
  classLoader: '',
};

export default Loader;



// WEBPACK FOOTER //
// ./src/screens/SharedComponents/Loader/index.js